<template>

    <div class="sb-table-container">

        <div class="sb-table-btn-group">

            <CustomDropdown
                v-for="dropdown in updatedDropdownList"
                :key="dropdown.title"
                :dropdown="dropdown"
            >
                {{ dropdown.value || dropdown.title }}
            </CustomDropdown>
        </div>

        <div class="sb-table-main"> 

            <el-table
                :data="bTableData"
                max-height="450"
                :row-class-name="generateRowClass"
                @current-change="handleRowClick"
                :highlight-current-row="false"
                :cell-class-name="generateCellClass"
                :header-cell-class-name="generateHeaderCellClass"
            >

                <el-table-column
                    key="name"
                    label="名称"
                    prop="name"
                    :width="130"
                    align="center"
                >

                    <template slot-scope="scope">

                        <span 
                            style="color: #45D7F4; font-weight: bold"
                        >
                            {{ scope.row.name }}
                        </span>
                    </template>
                </el-table-column>

                <el-table-column
                    key="price"
                    label="注册资本(万元)"
                    prop="price"
                    :width="70"
                    align="center"
                >

                    <template slot="header">

                        <div>
                            注册资本
                        </div>
                        <div>
                            (万元)
                        </div>
                    </template>

                    <template slot-scope="scope">

                        <span 
                            style="color: #FC9175"
                        >
                            {{ scope.row.price }}
                        </span>
                    </template>
                </el-table-column>
            
                <el-table-column
                    key="patent"
                    label="专利数"
                    prop="patent"
                    :width="60"
                    align="center"
                >

                    <template slot-scope="scope">

                        <span 
                            style="color: #70FF92"
                        >
                            {{ scope.row.patent }}
                        </span>
                    </template>
                </el-table-column>

                <el-table-column
                    key="show_industry"
                    label="行业"
                    prop="show_industry"
                    align="center"
                >

                    <template slot-scope="scope">

                        <span 
                            style="color: #FFFFFF"
                        >
                            {{ scope.row.show_industry }}
                        </span>
                    </template>
                </el-table-column>
            </el-table>
        </div>

        <div class="sb-table-notice"> 
            注：
            <span 
                style="background-color: #1B50B2; height: 0.7rem; width: 1.2rem; display: inline-block; margin-right: 0.5rem">
            </span>
            既属于专精特新企业，也属于全国瞪羚企业
        </div>
    </div>
</template>

<script>

    import { mapState, mapMutations } from "vuex";

    import CustomDropdown from "@/components/CustomDropdown";

    export default {
        name: "SBTable",
        components: {
            CustomDropdown
        },
        computed: {
            ...mapState([ "enterprise", "industry", "bTableData", "tOption", "bData" ]),
            updatedDropdownList() {
                return this.constants.dropdownList.map(dropdown => {

                    const { options, dropdownType, value } = dropdown;

                    let updatedOptions = options;
                    let updatedValue = value;

                    switch(dropdownType) {
                        case "eDropdown":

                            updatedOptions = options.map(option => {

                                const key = option.includes("所有")? "": `${option}库`;

                                const { length } = this.bData.filter(element => element.category.includes(key));

                                return `${option}(${length})`;
                            });

                            break;
                        case "iDropdown":

                            updatedOptions = options.map(option => {

                                const key = option.includes("所有")? "": option;

                                const updatedEnterprise = this.enterprise? this.enterprise.split("(")[0] : "";

                                const { length } = this.bData.filter(
                                    element => element.category.includes(updatedEnterprise)
                                ).filter(element => element.search_industry.includes(key));

                                return `${option}(${length})`;
                            });

                            updatedValue = updatedOptions.filter(
                                opt => opt.includes(updatedOptions.map(el => el.split("(")[0]
                            ).filter(el => el === value.split("(")[0])[0]))[0];

                            break;
                    }

                    return {
                        ...dropdown,
                        options: updatedOptions,
                        value: updatedValue
                    };
                });
            }
        },
        data() {

            return {
                constants: {
                    dropdownList: [
                        {
                            title: "企业类别",
                            type: "1",
                            options: [
                                "所有企业",
                                "专精特新企业",
                                "全国瞪羚企业"
                            ],
                            dropdownType: "eDropdown",
                            dropdownEventType: "toggleEDropdown",
                            optionEventType: "updateEnterprise",
                            value: ""
                        },
                        {
                            title: "筛选行业",
                            type: "2",
                            options: [
                                "所有行业",
                                "制造业",
                                "科学研究和技术服务业",
                                "信息传输、软件和信息技术服务业",
                                "建筑业",
                                "交通运输、仓储和邮政业",
                                "农、林、牧、渔业",
                                "水利、环境和公共设施管理业",
                                "电力、热力、燃气及水生产和供应业",
                                "批发和零售业",
                                "金融业",
                            ],
                            dropdownType: "iDropdown",
                            dropdownEventType: "toggleIDropdown",
                            optionEventType: "updateIndustry",
                            value: ""
                        }
                    ],
                    columns: [
                        {
                            label: "公司名",
                            prop: "name",
                            key: "name",
                            width: 100
                        },
                        {
                            label: "注册资本(万人民币)",
                            prop: "price",
                            key: "price",
                            width: 60
                        },
                        {
                            label: "专利数",
                            prop: "patent",
                            key: "patent",
                            width: 60
                        },
                        {
                            label: "行业",
                            prop: "show_industry",
                            key: "show_industry"
                        }
                    ]
                }
            };
        },
        methods: {
            ...mapMutations(["updateSelectedEnterprise"]),
            generateRowClass({ row }) {

                const { category } = row;

                const rowClass = category.split(",").length > 1? "special-table-row" : "normal-table-row";

                return rowClass;
            },
            handleRowClick(record) {
                
                const { type } = this.tOption;

                if (type !== 4) {
                    return;
                }

                const { coordinate } = record;

                const coord = coordinate.split(",");

                this.updateSelectedEnterprise({
                    ...record,
                    coord
                });
            },
            generateCellClass({ columnIndex }) {
                return columnIndex === 3? "st-table-last-col" : "";
            },
            generateHeaderCellClass({ columnIndex }) {
                return  columnIndex === 3? "st-table-last-col" : "";
            }
        },
        watch: {
            enterprise: {
                immediate: true,
                handler(val) {
                    this.constants.dropdownList[0].value = val;
                }
            },
            industry: {
                immediate: true,
                handler(val) {
                    this.constants.dropdownList[1].value = val;
                }
            }
        } 
    };
</script>

<style lang="scss" scoped>

    .sb-table-container {
        
        margin: 2rem 1rem;
        margin-top: 1.5rem;
        margin-left: 0.3rem;
        margin-right: 0.3rem;
        margin-bottom: 0;

        .sb-table-btn-group {
            display: flex;
            flex-direction: row;
            align-items: flex-start;
            justify-content: space-around;

            div:nth-of-type(1) {
                margin-right: 1.5rem;
            }
        }

        .sb-table-notice {
            color: #A7C6FF;
            font-size: 10px;
            margin-left: 0.5rem;
            margin-top: 1rem;
            display: flex;
            flex-direction: row;
            align-items: center;
        }

        .sb-table-main {
            margin-top: 1rem;
        }
    }

    /deep/.st-table-last-col {
        border-right: none !important;
    }
</style>

<style lang="scss">

    .ant-table-column-title {
        color: white;
    }

    .ant-table-tbody {
        background-color: #00057D;
    }

    .ant-table-tbody > tr > td {
        border-bottom: 1px solid #45D7F4;
    }

    .ant-table-header {
        height: 4rem;
        line-height: 1rem;
        font-size: 12px;
        border-top: 1px solid #0ECFFF;
        border-bottom: 1px solid #0ECFFF !important;
    }

    .ant-table-small {
        border: none;
    }

    .ant-table-body {
        .ant-table-row-cell-break-word {
            border-right: 1px dotted #45D7F4;
        }
    }

    .normal-table-row {
        background-color: #00057D !important;
    }

    .special-table-row {
        background-color: #1B50B2 !important;
    }

    .ant-table-thead > tr.ant-table-row-hover:not(.ant-table-expanded-row):not(.ant-table-row-selected) > td, 
    .ant-table-tbody > tr.ant-table-row-hover:not(.ant-table-expanded-row):not(.ant-table-row-selected) > td, 
    .ant-table-thead > tr:hover:not(.ant-table-expanded-row):not(.ant-table-row-selected) > td, 
    .ant-table-tbody > tr:hover:not(.ant-table-expanded-row):not(.ant-table-row-selected) > td {
        background-color: #00057D;
    }

    .el-table td.el-table__cell, .el-table th.el-table__cell.is-leaf {
        border-bottom: 0.3px solid #0ECFFF !important;
        border-right: 0.3px solid #0ECFFF;
    }

    .el-table th.el-table__cell {
        background-color: #00046A !important;
        border-top: 0.3px solid #0ECFFF !important;
    }

    .el-table th.el-table__cell>.cell {
        color: white !important;
    }

    .el-table--enable-row-hover .el-table__body tr:hover>td.el-table__cell {
        background-color: rgba(113, 255, 163, 0.5) !important;
    }

    .el-table--enable-row-transition .el-table__body td.el-table__cell {
        padding-top: 0.1rem;
        padding-bottom: 0;
    }

    .el-table th.el-table__cell {

        .cell {
            display: flex;
            flex-direction: column;
            justify-content: center;
            align-items: center;
        }
    }

    .st-table-main {

        .el-table th.el-table__cell {
            background-color: #2126A2 !important;
            padding-top: 0;
            padding-bottom: 0;
        }
    }

    .sb-table-main {

        .el-table th.el-table__cell {
            background-color: #00046A !important;
            padding-top: 0;
            padding-bottom: 0;
        }

        .el-table .cell {
            line-height: 1rem;
        }

    }

    .el-table {
        background-color: #00057D !important;
    }

    .el-table tr {
        background-color: #00057D;
    }
</style>